import { createSlice } from "@reduxjs/toolkit";
import HbsYatakGrupDTO from "src/models/GenelTanimlar/HbsYatakGrupDTO";
import HbsYatakTanimDTO from "src/models/GenelTanimlar/HbsYatakTanimDTO ";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";

interface IYatakTanim {
    YatakTanim1ActiveRow: HbsYatakGrupDTO;
    YatakTanim2ActiveRow: HbsYatakTanimDTO;
    

}

const YatakTanimSlice = createSlice <IYatakTanim, MapReducerPayloads<IYatakTanim, {
    setYatakTanim1ActiveRow: HbsYatakGrupDTO,
    setYatakTanim2ActiveRow: HbsYatakTanimDTO,
    }>>({


        name: 'yatakTanim',
        initialState: {
            YatakTanim1ActiveRow: new HbsYatakGrupDTO(),
            YatakTanim2ActiveRow: new HbsYatakTanimDTO(),

        },
        reducers: {
            setYatakTanim1ActiveRow: (state, action) => {
                state.YatakTanim1ActiveRow = action.payload;
            },
            setYatakTanim2ActiveRow: (state, action) => {
                state.YatakTanim2ActiveRow = action.payload;
            },
        }
    })
export default YatakTanimSlice;